import { v4 as uuidv4 } from 'uuid'

export const clientTerminationTestData = {
  title: 'Client Termination',
  item: '3 Year Avg Term Rate - 4.8 Households',
  key: uuidv4()
}
